import React, { useEffect, useState } from 'react';
import { Autocomplete, Box, TextField } from '@mui/material';
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import "components/commonMultiForm/CommonMultiForm.scss";
import { useSelector } from 'react-redux';


const CommonAutoComplete = () => {

    const companyID = localStorage.getItem("subCompany")?.length > 0 && JSON.parse(localStorage.getItem("subCompany"));
    const [value, setValue] = useState(companyID ? companyID : {});
    const profile =  useSelector((state) => state?.userProfile?.profileDetails?.data);
    const companyList = profile?.companies?.map((data, index ) => ({label: data?.name, value: data?.id}));

    const handleSetValue = (e, newValue) => {
        localStorage.setItem("subCompany", JSON.stringify(newValue));
        window.location.reload();
    }

    useEffect(() => {
        setValue(companyID)
    }, [])

  return (
    <Box className="customAutoComplete companyListAutoComplete">
        <Autocomplete
            size="medium"
            name={"companyList"}
            hiddenlabel="true"
            clearIcon={null}
            value={value}
            popupIcon={<ExpandMoreRoundedIcon />}
            disabled={companyList?.length === 1}
            options={companyList?.length ? companyList : []}
            defaultValue={companyList?.[0]}
            filterSelectedOptions
            onChange={(e, newValue) =>
                handleSetValue(e, newValue)
            }
            renderOption={(props, option) => (
            <Box {...props}>{option?.label}</Box>
            )}
            renderInput={(params) => (
            <TextField
                {...params}
                margin="normal"
                placeholder={"Choose Companys"}
                inputProps={{
                ...params.inputProps,
                autoComplete: "off",
                }}
            />
            )}
        />
  </Box>
  )
}

export default CommonAutoComplete
